export default "__VITE_ASSET__07df6bca__"